/*
 *  Document   : consultant-add-candidate.js
 *  Author     : BDSA
 *
 */

// Import global dependencies

// Import required modules

// Tools
import ExaHelpers from "../exa_helpers";
import Fuse from 'fuse.js';

export default class ConstultantAddCandidate {

    /*
    * Auto called when creating a new instance
    *
    */
    constructor() {
        window["ConstultantAddCandidate"] = this;
        this.init();
    }

    /*
     * init
     *
     */
    init() {

        var swal = Swal.mixin({
            buttonsStyling: !1,
            customClass: {
                confirmButton: "btn btn-success m-1",
                cancelButton: "btn btn-danger m-1",
                input: "form-control"
            }
        });


        let $updateStatusForm = $('#add-teamer-form');

       /* $updateStatusForm.on('submit', function (e) {
            e.preventDefault();
        });*/

        $updateStatusForm.find('[type="submit"].js-swal-confirm').on('click', function (e) {
            e.preventDefault();
            let $form = $(e.target).parents('form');

            if( ($('#cjt_id').val() == null) || ( $('#candidate_id').val() == "" ) ){
                alert('Veuillez choisir un teamer et son métier');
                return false;
            }

            //console.log( $('#cjt_id').val() );

            swal.fire({
                title: jsVars.confirmActionTitle,
                text: "",
                icon: "warning",
                showCancelButton: !0,
                customClass: {confirmButton: "btn btn-danger m-1", cancelButton: "btn btn-secondary m-1"},
                confirmButtonText: jsVars.confirmButtonText,
                cancelButtonText: jsVars.cancelButtonText,
                html: !1,
                preConfirm: function (e) {

                   if( ($('#cjt_id').val() != "") && ( $('#candidate_id').val() != "" ) ){
                        return true;
                    }else{
                        return false;
                    }

                }.bind(this)
            }).then((function (n) {
                n.value ?
                    $updateStatusForm.trigger('submit') :
                    "cancel" === n.dismiss
            }))

        }.bind(this));



        this.initTeamersAutocomplete();

    }


    initTeamersAutocomplete() {
        ConstultantAddCandidate.removedAcItems = [];

        const fuse = new Fuse(jsVars.teamersAutocomplete, {
            minMatchCharLength: 3,
            threshold: 0.3,
            distance: 1000,
            keys: ["last_name"],
            getFn: (obj, path) => {
                return obj.last_name.normalize('NFD').replace(/[\u0300-\u036f]/g, "");
            }
        })

        let $jtAc = $("#teamersAutocomplete");
        let $candidate_id = $("#candidate_id");
        let $acContainer = $jtAc.parent().find('.autocomplete-container');
        let $jtInput = $('select[name="teamers"]');
        let $cjt_id = $('select[name="cjt_id"]');

        if ($jtInput.prop('disabled')) {
            // Makes no sense to load the rest when input is disabled
            return false;
        }

        $jtAc.autocomplete({
            delay: 0,
            minLength: 2,
            source: function (req, callback) {
                let term = req.term.normalize('NFD').replace(/[\u0300-\u036f]/g, "");

                let options = [];
                $.each(fuse.search(term, {limit: 10}), function (index, obj) {
                    options.push({value: obj.item.id, label: obj.item.last_name+" "+obj.item.first_name+" ("+obj.item.email+")"});
                });

                callback(options);
            },
            select: function (event, ui) {

                $jtInput.find(`option`).remove();
                $cjt_id.find(`option:not([disabled])`).remove();
                $acContainer.html('');

                var label = ui.item.label;
                var value = ui.item.value;
                $jtInput.append($('<option>', {
                    value: value,
                    text: label
                }));

                $jtInput.find(`option[value="${value}"]`).prop('selected', true);
                $jtInput.change();
                $acContainer.append(`
                    <span class="autocomplete-item" data-value="${value}"><i class="fa fa-fw fa-times"></i>${label}</span>
                `);

                $candidate_id.val(value);



                let indexToRemove = fuse._docs.findIndex(x => x.id === parseInt(value));


                $.each(fuse._docs[indexToRemove].fullProfessions, function (index, obj) {
                    $cjt_id.append($('<option>', {
                        value: index,
                        text: obj
                    }));
                });




                if (indexToRemove !== -1) {
                    ConstultantAddCandidate.removedAcItems.push(fuse._docs[indexToRemove]);
                    fuse.removeAt(indexToRemove);
                }

                $(this).val('');
                return false;
            },
            focus: function (event, ui) {
                $(this).val(ui.item.label);
                return false;
            }
        });

        $.each($jtInput.val(), function (_i, value) {
            let indexToRemove = fuse._docs.findIndex(x => x.id === parseInt(value));
            if (indexToRemove !== -1) {
                ConstultantAddCandidate.removedAcItems.push(fuse._docs[indexToRemove]);
                fuse.removeAt(indexToRemove);
            }
        })

        $acContainer.on('click', '.fa-times', function (e) {
            let $item = $(e.target).parent();
            let value = $item.data('value');
            let $option = $jtInput.find(`option[value="${value}"]`);

            $option.prop('selected', false);
            $option.remove();
            $item.remove();
            $jtInput.change();
            $cjt_id.find(`option:not([disabled])`).remove();
            $cjt_id.find(`option`).eq(0).prop('selected', true);
            $cjt_id.change();
            $candidate_id.val('');

            let indexToAdd = ConstultantAddCandidate.removedAcItems.findIndex(x => x.id === parseInt(value));
            if (indexToAdd !== -1) {
                fuse.add(ConstultantAddCandidate.removedAcItems[indexToAdd]);
            }
        })
    }



}
